import {
    PENDING_PAYMENTS_LIST_START,
    PENDING_PAYMENTS_LIST_SUCCESS,
    PENDING_PAYMENTS_LIST_ERROR,
    COMPLETED_PAYMENTS_LIST_START,
    COMPLETED_PAYMENTS_LIST_SUCCESS,
    COMPLETED_PAYMENTS_LIST_ERROR,
    // GET_PANALTY_PAYMENT_DETAIL_SUCCESS,
    // GET_PANALTY_PAYMENT_DETAIL_ERROR,
    // GET_PANALTY_PAYMENT_DETAIL_START,
    CANCEL_PAYMENTS_LIST_START,
    CANCEL_PAYMENTS_LIST_SUCCESS,
    CANCEL_PAYMENTS_LIST_ERROR,
} from "Constant";

const initialState = {
    loading: false,
    pendingPaymentsData: {},
    completedPaymentsData: {},
    //panaltyPaymentDetail: [],
    cancelPaymentsData: {},
};
export default function PaymentsListReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case CANCEL_PAYMENTS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case CANCEL_PAYMENTS_LIST_SUCCESS:
            return {
                ...state,
                cancelPaymentsData: action.payload,
                loading: false,
            };
        case CANCEL_PAYMENTS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case PENDING_PAYMENTS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case PENDING_PAYMENTS_LIST_SUCCESS:
            return {
                ...state,
                pendingPaymentsData: action.payload,
                loading: false,
            };
        case PENDING_PAYMENTS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case COMPLETED_PAYMENTS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case COMPLETED_PAYMENTS_LIST_SUCCESS:
            return {
                ...state,
                completedPaymentsData: action.payload,
                loading: false,
            };
        case COMPLETED_PAYMENTS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        // case GET_PANALTY_PAYMENT_DETAIL_START:
        //     return {
        //         ...state,
        //         loading: true,
        //     };
        // case GET_PANALTY_PAYMENT_DETAIL_SUCCESS:
        //     return {
        //         ...state,
        //         panaltyPaymentDetail: action.payload,
        //         loading: false,
        //     };
        // case GET_PANALTY_PAYMENT_DETAIL_ERROR:
        //     return {
        //         ...state,
        //         loading: false,
        //         message: action.error.message,
        //     };
        default:
            return state;
    }
}

